import React from 'react';
import cn from 'classnames';

import CN from './Spinner.module.scss';

// DEPRECATED: try to use InlineSpinner instead and/or rename this one to PageSpinner
const Spinner = ({ color, messageColor, message, background, positionTop }) => (
  <div data-bem="Spinner" className={CN.loaderBackground} style={{ backgroundColor: background, top: positionTop }}>
    <p data-bem="Spinner__message" className={CN.loadingText} style={{ color: messageColor }}>
      {message}
    </p>
    <div data-bem="Spinner__animation" className={cn(CN.loader, CN.fixed)}>
      <svg className={CN.circular}>
        <circle
          className="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="3"
          strokeMiterlimit="10"
          stroke={color}
        />
      </svg>
    </div>
  </div>
);

export default Spinner;
